module.exports = __webpack_public_path__ + "img/María del Carmen Prado Sandoval_Gerente Administrativo.98c11e75.png";